import { OktaAuth } from "@okta/okta-auth-js";

function normalizeIssuer(issuer: string): string {
  return issuer.replace(/\/+$/, "");
}

export const oktaAuth = new OktaAuth({
  issuer: normalizeIssuer(import.meta.env.VITE_OKTA_ISSUER),
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI,
  postLogoutRedirectUri: import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI,
  scopes: ["openid", "profile", "email", "offline_access"],
  pkce: true,
  tokenManager: {
    storage: "localStorage",
    autoRenew: true,
  },
});
